import { Component, OnInit, ViewChild } from '@angular/core';
import { GraphQLClient } from '../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { bodega } from '../../shared/object/bodega.model';
import { validate } from 'graphql';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { SecurityService } from '../../shared/services/security.service';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: 'app-bodega',
  templateUrl: './bodega.component.html',
  styleUrls: ['./bodega.component.scss'],
  providers: [SecurityService, ValidadoresService],
})
export class BodegaComponent implements OnInit {
  private client: GraphQLClient = null;
  listaBodega: bodega[];
  selectedBodega: bodega;
  bodega: bodega;
  public formAgregarBodega: FormGroup;
  public formEditarBodega: FormGroup;

  public rut_empresa;
  public sucursal_codigo;
  public busquedaEstado;
  @ViewChild('centralLarge', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarBodega', { static: true }) editarModal: ModalDirective;
  public codgo_modulo:number = 4;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());

  constructor(
    client: GraphQLClient,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService 
  ) {
    this.client = client;
    this.busquedaEstado = 1;
    this.formAgregarBodega = this.construyeFormAgrega();
    this.formEditarBodega = this.construyeFormEdita();
  }

  construyeFormAgrega() {
    return new FormGroup({
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(150),
      ]),
      observaciones: new FormControl('', [Validators.maxLength(200)]),
      activo: new FormControl(true),
      principal: new FormControl(true),
    });
  }
// COMENTARIO

  construyeFormEdita() {
    return new FormGroup({
      codigo: new FormControl(''),
      rut_empresa: new FormControl(''),
      sucursal_codigo: new FormControl(''),
      nombre: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(20),
      ]),
      descripcion: new FormControl('', [
        Validators.required,
        Validators.minLength(5),
        Validators.maxLength(150),
      ]),
      observaciones: new FormControl('', [Validators.maxLength(200)]),
      activo: new FormControl(true),
      principal: new FormControl(true),
    });
  }
  ngOnInit() {
    this.selectedBodega = {
      rut_empresa: null,
      sucursal_codigo: null,
      codigo: null,
      nombre: '',
      descripcion: '',
      activo: true,
      observaciones: '',
      principal: true,
    };
    this.rut_empresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursal_codigo = this.accesolocalstorage.getSucursalCodigo();

    this.obtenerDatosBodega(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo)
    );
  }

  filtraxEstado() {
    this.obtenerDatosBodega(
      Number(this.rut_empresa),
      Number(this.sucursal_codigo)
    );
  }

  cambiaEstado(bodega_seleccionada: bodega) {
    if (this.validaCambiaEstado(bodega_seleccionada)) {
      if (bodega_seleccionada.activo) {
        bodega_seleccionada.activo = false;
      } else {
        bodega_seleccionada.activo = true;
      }
      this.refrescar(bodega_seleccionada);
    }
  }

  muestraModalAgrega() {
    this.selectedBodega = {
      rut_empresa: null,
      sucursal_codigo: null,
      codigo: null,
      nombre: '',
      descripcion: '',
      activo: true,
      observaciones: '',
      principal: true,
    };
    this.formAgregarBodega.reset();
  }

  obtenerDatosBodega(rut_empresa: number, sucursal_codigo: number) {
    let self = this;

    this.client.query(
      {
        query: gql`
          query(
            $rut_empresa: Decimal
            $sucursal_codigo: Decimal
            $tipobusqueda: Int
          ) {
            bodega {
              obtenerSegunFiltro(
                filtro: {
                  exacto: {
                    rut_empresa: $rut_empresa
                    sucursal_codigo: $sucursal_codigo
                    tipobusqueda: $tipobusqueda
                  }
                }
              ) {
                respuesta {
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    descripcion
                    activo
                    observaciones
                    principal
                  }
                }
              }
            }
          }
        `,
        fetchPolicy: 'no-cache',
        variables: {
          rut_empresa: rut_empresa,
          sucursal_codigo: sucursal_codigo,
          tipobusqueda: this.busquedaEstado,
        },
      },
      function (respuesta) {
        self.listaBodega =
          respuesta.data.bodega.obtenerSegunFiltro.respuesta.registros;
      }
    );
  }

  get frmAgregaNombre() {
    return this.formAgregarBodega.get('nombre');
  }
  get frmAgregaDescripcion() {
    return this.formAgregarBodega.get('descripcion');
  }
  get frmAgregaObservaciones() {
    return this.formAgregarBodega.get('observaciones');
  }
  get frmAgregaActivo() {
    return this.formAgregarBodega.get('activo');
  }
  get frmAgregaPrincipal() {
    return this.formAgregarBodega.get('principal');
  }

  get frmEditarCodigo() {
    return this.formEditarBodega.get('codigo');
  }
  get frmEditarRut_Empresa() {
    return this.formEditarBodega.get('rut_empresa');
  }
  get frmEditarSucursal_Codigo() {
    return this.formEditarBodega.get('sucursal_codigo');
  }
  get frmEditarNombre() {
    return this.formEditarBodega.get('nombre');
  }
  get frmEditarDescripcion() {
    return this.formEditarBodega.get('descripcion');
  }
  get frmEditarObservaciones() {
    return this.formEditarBodega.get('observaciones');
  }
  get frmEditarActivo() {
    return this.formEditarBodega.get('activo');
  }
  get frmEditarPrincipal() {
    return this.formEditarBodega.get('principal');
  }

  validainsertar(): boolean {
    const valorActivo = this.frmAgregaActivo.value === null ? false : this.frmAgregaActivo.value;
    const valorPrincipal = this.frmAgregaPrincipal.value === null ? false : this.frmAgregaPrincipal.value;

    this.frmAgregaActivo.setValue(valorActivo);
    this.frmAgregaPrincipal.setValue(valorPrincipal);

    if (
      this.frmAgregaActivo.value === false &&
      this.frmAgregaPrincipal.value === true
    ) {
      const resp = window.confirm(
        'Ha seleccionado que esta es la bodega principal, pero indicó que está desactivada. Presione ACEPTAR para cambiar estado a Activo o cancele la operación'
      );
      if (resp) {
        this.frmAgregaActivo.setValue(true);
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  insertar() {
    if (this.validainsertar()) {
      this.selectedBodega.nombre = this.frmAgregaNombre.value;
      this.selectedBodega.descripcion = this.frmAgregaDescripcion.value;
      this.selectedBodega.observaciones = this.frmAgregaObservaciones.value;
      this.selectedBodega.activo = this.frmAgregaActivo.value;
      this.selectedBodega.principal = this.frmAgregaPrincipal.value;

      this.selectedBodega.codigo = 0;
      this.selectedBodega.rut_empresa = Number(this.rut_empresa);
      this.selectedBodega.sucursal_codigo = Number(this.sucursal_codigo);

      this.postBodega(this.selectedBodega);
    }
  }

  postBodega(bodega: bodega) {
    let self = this;
    var bodyx = bodega;
    //var self = this;
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: bodegaInputType) {
            bodega {
              agregar(entidad: $entidad) {
                respuesta {
                  rut_empresa
                  sucursal_codigo
                  codigo
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        setTimeout(
          () =>
            self.obtenerDatosBodega(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  validaCambiaEstado(bodega_a_modificar: bodega): boolean {
    if (
      bodega_a_modificar.principal === true &&
      bodega_a_modificar.activo === true
    ) {
      alert(
        'No se puede cambiar el estado mientras esta sea la bodega principal.'
      );
      return false;
    } else {
      return true;
    }
  }

  valida(bodega_a_modificar: bodega): boolean {
    if (
      bodega_a_modificar.principal === true &&
      bodega_a_modificar.activo === false
    ) {
      const confirmacion = window.confirm(
        'La bodega principal no puede estar desactivada. Se cambiará estado a ACTIVO. ¿Esta seguro?'
      );

      if (confirmacion) {
        bodega_a_modificar.activo = true;
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
  actualizar() {
    this.selectedBodega.codigo = this.frmEditarCodigo.value;
    this.selectedBodega.rut_empresa = this.frmEditarRut_Empresa.value;
    this.selectedBodega.sucursal_codigo = this.frmEditarSucursal_Codigo.value;
    this.selectedBodega.nombre = this.frmEditarNombre.value;
    this.selectedBodega.descripcion = this.frmEditarDescripcion.value;
    this.selectedBodega.activo = this.frmEditarActivo.value;
    this.selectedBodega.principal = this.frmEditarPrincipal.value;

    if (this.valida(this.selectedBodega)) {
      this.refrescar(this.selectedBodega);
    }
  }

  refrescar(bodega_modificada: bodega) {
    let self = this;
    var bodyx = bodega_modificada;
    delete bodega_modificada['__typename'];
    this.client.mutate(
      {
        mutation: gql`
          mutation($entidad: bodegaInputType) {
            bodega {
              guardar(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  nombre
                  descripcion
                }
              }
            }
          }
        `,
        variables: {
          entidad: bodyx,
        },
      },
      function (respuesta) {
        if (respuesta.data.bodega.guardar.respuesta == null) {
          if (respuesta.data.bodega.guardar.mensajes.length > 0) {
            alert(respuesta.data.bodega.guardar.mensajes[0].texto);
          }
        }
        setTimeout(
          () =>
            self.obtenerDatosBodega(
              Number(self.rut_empresa),
              Number(self.sucursal_codigo)
            ),
          1000
        );
      }
    );
  }

  showForEdit(bod: bodega) {
    this.formEditarBodega.reset();
    this.selectedBodega = Object.assign({}, bod);
    this.frmEditarNombre.setValue(bod.nombre);
    this.frmEditarDescripcion.setValue(bod.descripcion);
    this.frmEditarObservaciones.setValue(bod.observaciones);
    this.frmEditarActivo.setValue(bod.activo);
    this.frmEditarPrincipal.setValue(bod.principal);
    this.frmEditarCodigo.setValue(bod.codigo);
    this.frmEditarRut_Empresa.setValue(bod.rut_empresa);
    this.frmEditarSucursal_Codigo.setValue(bod.sucursal_codigo);
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  permitirCambioEstado(bodega_seleccionada: bodega) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(bodega_seleccionada);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
